export const vehicleTypes = [
    { id: "1", name: "AUTOS", file: "acara_precios_autos.pdf" },
    { id: "2", name: "MOTOS", file: "acara_precios_motos.pdf" },
    { id: "3", name: "CAMIONES", file: "acara_precios_camiones.pdf" },
    { id: "4", name: "MAQUINARIA AGRICOLA", file: "acara_precios_maquinaria_agricola.pdf" },
    { id: "5", name: "MAQUINARIA_VIAL" },
    { id: "6", name: "ACOPLADOS" },
    { id: "7", name: "SEMI REMOLQUES" },
  ];